
export const INVALID_PHONE = 'Please enter a valid phone number.'
